import { getOneHrCourse } from "api/oneHR";
import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router-dom";
import images from "ressources/images";
import "./Show.css";

/**
 * Cette page n'est pas utilisée parce que l'on redirige directement vers oneHR
 * Dans le cas où oneHR se mettrait enfin à rediriger correctement, alors on pourrait utiliser à nouveau cette page
 */
const Show = () => {
  const { i18n } = useTranslation();
  const match = useRouteMatch();
  const history = useHistory();
  const [course, setcourse] = useState();
  const pageRef = useRef();

  const goBack = () => {
    history.goBack();
  };

  const fetchData = async () => {
    const course = await getOneHrCourse(match.params.id);

    setcourse(course);
  };

  const handleResize = () => {
    const layoutContainer = document.querySelector(
      ".default-layout--container"
    );

    const containerHeight = layoutContainer.clientHeight;

    if (pageRef.current) {
      pageRef.current.style.height = containerHeight + "px";
    }
  };

  useEffect(() => {
    fetchData();
  }, [match, i18n]);

  useEffect(() => {
    // If this was done properly in the first place, this would not be needed,
    // but it would require too many changes and verification to use height: 100%
    // Once the new css viewport units are compatible with most browsers this could be replaced
    // with something like this: "height: calc(100svh - XXpx);"
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="onehr-show" ref={pageRef}>
      <div className="onehr-header">
        <button className="onehr-header__close-btn" onClick={goBack}>
          <img src={images.closeCross} alt="" />
        </button>
      </div>
      {course && (
        <iframe className="onehr-iframe" src={course.courseUrl}></iframe>
      )}
    </div>
  );
};

export default Show;
